require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-artisan-precinct-decmeber-2020-timeplase.json") })
        }
      }, "path---news-artisan-precinct-decmeber-2020-timeplase");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-artisan-precinct-decmeber-2020-timeplase!./.cache/json/news-artisan-precinct-decmeber-2020-timeplase.json
// module id = 790
// module chunks = 231608221292675